var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowRightOutlined = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m7.266 13.466 3.536-3.472-3.536-3.472A.9.9 0 0 1 7 5.89a.88.88 0 0 1 .266-.631.9.9 0 0 1 .643-.261.92.92 0 0 1 .642.26l4.182 4.108a.9.9 0 0 1 .267.631.88.88 0 0 1-.267.631l-4.182 4.108a.92.92 0 0 1-1.285 0 .9.9 0 0 1 0-1.271"
})));
export default SvgArrowRightOutlined;